import styled from 'styled-components';

export const PhotoUserWrapper = styled.div`
  border-radius: 50%;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1200px) {
    scale: 0.7;
  }

  svg {
    stroke: unset !important;
  }
`;
